// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo ,useState} from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/customers/customersActions";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../../../_metronic/_helpers";
import * as uiHelpers from "../CustomersUIHelpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useCustomersUIContext } from "../CustomersUIContext";

export function CustomersTable() {
  // Customers UI Context
  const customersUIContext = useCustomersUIContext();
  const [entities, setEntities] = useState([])
  const customersUIProps = useMemo(() => {
    return {
      ids: customersUIContext.ids,
      setIds: customersUIContext.setIds,
      queryParams: customersUIContext.queryParams,
      setQueryParams: customersUIContext.setQueryParams,
      openEditCustomerDialog: customersUIContext.openEditCustomerDialog,
      openDeleteCustomerDialog: customersUIContext.openDeleteCustomerDialog,
    };
  }, [customersUIContext]);

  // Getting curret state of customers list from store (Redux)
  
  const dispatch = useDispatch();
  
  const entity =  useSelector(state => state.staff.allstaff)
  const authtoken = useSelector(state => state.user.authtoken)

    console.log(entity);
  const { currentState } = useSelector(
    (state) => ({ currentState: state.customers }),
    shallowEqual
  );

  const { totalCount, listLoading } = currentState;

  // Customers Redux state
  useEffect(() => {
    GetAllCampuses()
  }, [customersUIProps.queryParams, dispatch,entity]);
  
  useEffect(() => {
    setEntities(entity)
  }, [entity])



 







  const GetAllCampuses = async () => {
    await fetch(`/staffmember`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authtoken}`
        }
    })
        .then((res) => res.json())
        .then((data) => {
          dispatch({
            type: 'GET_ALL_STAFF',
            payload: data.payload
        })
        })
        .catch((err) => {
            console.log(err)
        })
}
  
  // Table columns
  const columns = [
    {
      dataField: "id",
      text: "ID",
      
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "full_name",
      text: " Name ",
      
      sortCaret: sortCaret,
      headerSortingClasses,
    },
   
    {
      dataField: "user.email",
      text: "Account Title",
      
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "applied_for",
      text: "Role",
      sort: false,
      sortCaret: sortCaret,
    },
    {
      dataField: "campus_id",
      text: "Campus ID",
      sort: false,
      sortCaret: sortCaret,
    },
   
    {
      dataField: "cnic_no",
      text: "CNIC/B-Form",
      sort: false,
      sortCaret: sortCaret,
    },
   
    {
      dataField: "marital_status",
      text: "Marital Status",
      sort: false,
      sortCaret: sortCaret,
    },
   
    {
      dataField: "mobile_no",
      text: "Mobile No",
      sort: false,
      sortCaret: sortCaret,
    },
   
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditCustomerDialog: customersUIProps.openEditCustomerDialog,
        openDeleteCustomerDialog: customersUIProps.openDeleteCustomerDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: customersUIProps.queryParams.pageSize,
    page: customersUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  customersUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: customersUIProps.ids,
                  setIds: customersUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
